import { useDarkMode } from "../context/darkModeContext";
import "../css/DataDisplayElement.css";

interface Props {
  hidden: boolean;
  title: string;
  text: string;
  topElement?: boolean;
}

const DataDisplayElement = ({
  hidden,
  title,
  text,
  topElement = false,
}: Props) => {
  const { darkMode } = useDarkMode();
  return (
    <div className={hidden && !topElement ? "hidden" : "data-container"}>
      <p className="data-container-text-small">{title}</p>
      <p
        className={`data-container-text-medium${darkMode ? "--darkmode" : ""}`}
      >
        {text}
      </p>
    </div>
  );
};

export default DataDisplayElement;
